/* VB · Secciones de contenido de la ficha (sections/vb-pdp-*.liquid).
   Antes/después arrastrable · «Comprar ahora» vuelve a la compra · mitos rotando · vídeos de reseñas (uno a la vez).
   Idempotente por elemento (data-init) y re-inicializable en el editor (shopify:section:load). */
(() => {
  if (window.__vbPdpX) return;
  window.__vbPdpX = true;
  const RM = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const ba = (el) => {
    const r = el.querySelector('[data-ba-range]');
    if (!r) return;
    const set = (v) => el.style.setProperty('--p', `${v}%`);
    r.addEventListener('input', () => { set(r.value); el.classList.add('is-used'); });
    if (RM() || !('IntersectionObserver' in window)) return;
    // Pequeño vaivén al entrar en pantalla para invitar a arrastrar (prototipo)
    const io = new IntersectionObserver(([e], o) => {
      if (!e.isIntersecting) return;
      o.disconnect();
      let t0 = null;
      const anim = (t) => {
        if (el.classList.contains('is-used')) return;
        t0 ??= t;
        const k = (t - t0) / 1400;
        if (k > 1) { set(50); r.value = 50; return; }
        set(50 + Math.sin(k * Math.PI * 2) * 14);
        requestAnimationFrame(anim);
      };
      requestAnimationFrame(anim);
    }, { threshold: 0.5 });
    io.observe(el);
  };

  /* Mitos: rotan cada «Cambio cada» s. Se pausan al tocar/mantener en táctil (siguen 4 s después de
     soltar), con el foco de teclado dentro, fuera de pantalla y con la pestaña oculta; al reanudar sigue el tiempo que
     quedaba. El punto activo muestra el progreso. Reducción de movimiento = sin rotación. */
  const myths = (el) => {
    const qs = [...el.querySelectorAll('[data-myth]')];
    const dots = [...el.querySelectorAll('[data-myth-dot]')];
    if (qs.length < 2) return;
    const ms = Math.max(3000, Number(el.dataset.speed) || 10000);
    const auto = !RM();
    el.style.setProperty('--myth-ms', `${ms}ms`);
    el.classList.toggle('is-auto', auto);
    let i = 0, timer = null, left = ms, t0 = 0, touchT = null;
    const holds = new Set();
    const go = (n) => {
      i = (n + qs.length) % qs.length;
      left = ms;
      qs.forEach((q, j) => { q.classList.toggle('is-on', j === i); q.setAttribute('aria-hidden', String(j !== i)); });
      dots.forEach((d, j) => {
        d.classList.remove('is-on');
        if (j === i) { void d.offsetWidth; d.classList.add('is-on'); } // reinicia la barra de progreso
        d.setAttribute('aria-current', String(j === i));
      });
    };
    const run = () => {
      clearTimeout(timer); timer = null;
      if (!auto || holds.size) return;
      t0 = performance.now();
      timer = setTimeout(() => { go(i + 1); run(); }, left);
    };
    const hold = (r) => {
      if (holds.has(r)) return;
      if (!holds.size && timer) { clearTimeout(timer); timer = null; left = Math.max(0, left - (performance.now() - t0)); }
      holds.add(r);
      el.classList.add('is-paused');
    };
    const release = (r) => {
      if (!holds.delete(r) || holds.size) return;
      el.classList.remove('is-paused');
      run();
    };
    dots.forEach((d, j) => d.addEventListener('click', () => { go(j); run(); }));
    // Sin pausa al pasar el ratón (Alberto 29-oct: la barra congelada a medias parecía que «quería avanzar y no lo hacía»)
    el.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') return; clearTimeout(touchT); hold('touch'); });
    const up = (e) => { if (e.pointerType === 'mouse') return; clearTimeout(touchT); touchT = setTimeout(() => release('touch'), 4000); };
    el.addEventListener('pointerup', up);
    el.addEventListener('pointercancel', up);
    // Solo el foco de teclado pausa (un clic en un punto no deja la rotación parada para siempre)
    el.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) hold('focus'); });
    el.addEventListener('focusout', (e) => { if (!el.contains(e.relatedTarget)) release('focus'); });
    if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => (e.isIntersecting ? release('off') : hold('off')), { threshold: 0.25 }).observe(el);
    document.addEventListener('visibilitychange', () => (document.hidden ? hold('hidden') : release('hidden')));
    go(0);
    run();
  };

  const videos = (root) => {
    root.addEventListener('click', (e) => {
      const tile = e.target.closest('[data-rv-video]');
      if (!tile) return;
      const v = tile.querySelector('video');
      if (!v) return;
      if (v.paused) {
        // Solo un vídeo a la vez en toda la página
        document.querySelectorAll('video').forEach((x) => { if (x !== v && !x.paused) { x.pause(); x.closest('[data-rv-video]')?.classList.remove('is-playing'); } });
        if (!v.src && v.dataset.src) v.src = v.dataset.src;
        v.muted = false;
        v.play().then(() => tile.classList.add('is-playing')).catch(() => { v.muted = true; v.play().then(() => tile.classList.add('is-playing')).catch(() => {}); });
      } else {
        v.pause();
        tile.classList.remove('is-playing');
      }
    });
    root.querySelectorAll('[data-rv-video] video').forEach((v) => v.addEventListener('ended', () => v.closest('[data-rv-video]')?.classList.remove('is-playing')));
  };

  /* Tema sin publicar (preview / editor): textos que anuncian descuentos aún no cobrados. Mismo criterio que assets/vb.js
     («Enlaces de QA») y la ficha: publicado (role main) se queda el texto normal. */
  const PREVIEW = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
  const preview = (scope) => {
    if (!PREVIEW) return;
    scope.querySelectorAll('[data-vb-preview][hidden]').forEach((el) => {
      el.hidden = false;
      const live = el.previousElementSibling;
      if (live && live.hasAttribute('data-vb-live')) live.hidden = true;
    });
  };

  /* Combínalo sin combinaciones para esta ficha: recomendaciones de Shopify (misma sección renderizada) si las hay */
  const recs = async (el) => {
    const url = el.dataset.combRecs;
    const track = el.querySelector('[data-comb-track]');
    if (!url || !track) return;
    try {
      const res = await fetch(url);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const nt = doc.querySelector('[data-comb-track]');
      if (!nt || !nt.children.length) return;
      track.innerHTML = nt.innerHTML;
      track.scrollLeft = 0;
      track.dispatchEvent(new Event('scroll'));
    } catch (e) { /* se queda la lista por defecto */ }
  };

  const init = (scope = document) => {
    preview(scope);
    scope.querySelectorAll('[data-comb-recs]:not([data-init])').forEach((el) => { el.dataset.init = '1'; recs(el); });
    scope.querySelectorAll('[data-ba]:not([data-init])').forEach((el) => { el.dataset.init = '1'; ba(el); });
    scope.querySelectorAll('[data-myths]:not([data-init])').forEach((el) => { el.dataset.init = '1'; myths(el); });
    scope.querySelectorAll('[data-rv]:not([data-init])').forEach((el) => { el.dataset.init = '1'; videos(el); });
    if (window.VB && VB.scroller) scope.querySelectorAll('.vb-phow [data-vb-scroller], .vb-prev [data-vb-scroller], .vb-pcomb [data-vb-scroller]').forEach(VB.scroller);
  };

  // «Comprar» de la tarjeta de reseña: añade el producto (abre el carrito)
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-rv-add]');
    if (!b || !window.VB || !VB.cart) return;
    b.disabled = true;
    try { await VB.cart.add([{ id: Number(b.dataset.rvAdd), quantity: 1 }]); } catch (err) { /* el carrito muestra su propio aviso */ }
    b.disabled = false;
  });

  // «Comprar ahora»: lleva al bloque de compra de la ficha
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-pdp-top]');
    if (!a || a.getAttribute('href') !== '#MainContent') return;
    const buy = document.querySelector('[data-main-form]');
    if (!buy) return;
    e.preventDefault();
    const top = buy.getBoundingClientRect().top + scrollY - (innerHeight / 3);
    window.scrollTo({ top, behavior: RM() ? 'auto' : 'smooth' });
    setTimeout(() => buy.querySelector('[data-main-atc]')?.focus({ preventScroll: true }), RM() ? 0 : 600);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
